import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const FULL_2_TOWER_PERSONALIZED_TEST_NAME = 'HP_Full2TowerPersonalized_Aug2026';

/** First N recommendation IDs are reserved for the You'll Want All of these module. */
export const YOU_WANT_RECOMMENDATION_COUNT = 20;

export const trackFull2TowerPersonalizedTest = (): void => {
    trackAbTestV2Variant(FULL_2_TOWER_PERSONALIZED_TEST_NAME);
};

const isFull2TowerPersonalizedTestVariant = (): boolean =>
    getAbTestV2(FULL_2_TOWER_PERSONALIZED_TEST_NAME)?.variant === 'variant';

/**
 * Eligible users must have 2-tower recommendations before AB variant is considered.
 * Control users with recommendations still get exposure tracking; only the variant
 * flips curated grid sourcing.
 */
export const shouldUseFull2TowerPersonalizedVariant = (hasRecommendations: boolean): boolean =>
    hasRecommendations && isFull2TowerPersonalizedTestVariant();
